import React, { useContext } from 'react'
import { useAtom } from '@reatom/react'
import { PaymentAtom } from '@bfg/atoms/Payment'

const PaymentStatePayedContext = React.createContext()
const PaymentStateExpiredContext = React.createContext()
const PaymentStateLoadingContext = React.createContext()
const PaymentStateTrialUsedContext = React.createContext()

export function usePaymentPayed () {
  return useContext(PaymentStatePayedContext)
}

export function usePaymentExpired () {
  return useContext(PaymentStateExpiredContext)
}

export function usePaymentTrialState () {
  return useContext(PaymentStateTrialUsedContext)
}

export function usePaymentLoadingState () {
  return useContext(PaymentStateLoadingContext)
}

export function PaymentStateProvider ({ children }) {
  const paymentState = useAtom(PaymentAtom)

  // Проверяем что хотя бы один тип загружен для aPay
  const aPayLoaded = paymentState.aPay.weeklySub !== null
    || paymentState.aPay.oneTimePay !== null
    || paymentState.aPay.monthlySub !== null
    || paymentState.aPay.annualSub !== null

  // Проверяем что хотя бы один тип загружен для gPay
  const gPayLoaded = paymentState.gPay.weeklySub !== null
    || paymentState.gPay.oneTimePay !== null
    || paymentState.gPay.monthlySub !== null
    || paymentState.gPay.annualSub !== null

  // Загружено когда оба готовы
  const paymentStateLoading = aPayLoaded && gPayLoaded
  return (
    <PaymentStatePayedContext.Provider value={paymentState.payed}>
      <PaymentStateExpiredContext.Provider value={paymentState.expired}>
        <PaymentStateLoadingContext.Provider value={paymentStateLoading}>
          <PaymentStateTrialUsedContext.Provider value={paymentState.trial}>
            {children}
          </PaymentStateTrialUsedContext.Provider>
        </PaymentStateLoadingContext.Provider>
      </PaymentStateExpiredContext.Provider>
    </PaymentStatePayedContext.Provider>
  )
}